import { FileContentRendererConfig, RenderFormat } from '@/content-viewer/store/schemas'
import { MimeType } from '@/constants/constants-mime-types'
import { UserFileProcessingStatus } from '@/user_files/schemas/processing-status'
import { UserFileRead } from '@/uppy-file-upload/schemas'

/**
 * Shared mapping from a `UserFileRead` to a base renderer config, so the surfaces that
 * open a user file all derive the same renderer from `viewable_content`.
 */
export function buildUserFileRendererConfig(file: UserFileRead): FileContentRendererConfig | null {
  if (file.processing_status !== UserFileProcessingStatus.Completed) return null

  const viewable = file.viewable_content
  if (!viewable) return null

  if (viewable.content_type === MimeType.PDF) {
    return {
      format: RenderFormat.PDF,
    }
  }

  if (viewable.content_type === MimeType.MARKDOWN) {
    return {
      format: RenderFormat.MARKDOWN,
    }
  }

  return null
}
